import { TextAlignEnum as e } from "../text-align-enum.mjs";
import { jsx as t } from "react/jsx-runtime";
import { AlignCenterIcon as n, AlignJustifyIcon as r, AlignLeftIcon as i, AlignRightIcon as a } from "@systemeio/icons";
//#region src/extensions/text-align-extension/utils/text-align.tsx
var o = () => {
	let o = (o) => {
		switch (o) {
			case e.Left: return /* @__PURE__ */ t(i, {});
			case e.Right: return /* @__PURE__ */ t(a, {});
			case e.Center: return /* @__PURE__ */ t(n, {});
			case e.Justify: return /* @__PURE__ */ t(r, {});
		}
	};
	return Object.values(e).map((e) => ({
		value: e,
		label: e,
		customLabel: o(e)
	}));
}, s = (t) => {
	if (!t) return e.Left;
	let n = o().find(({ value: e }) => t.isActive({ textAlign: e }));
	return n ? n.value : e.Left;
};
//#endregion
export { s as getCurrentTextAlignValue, o as getTextAlignValues };
